import React, { PropsWithChildren } from 'react';
import { PolyfillTabsButtons } from '../../../components/CustomTabs/Tabs';
interface TabContainerInterface extends PropsWithChildren { length : number }

const TabContainer : React.FC<TabContainerInterface> = ({length, children}) => {
    return length && length == 1 ? <React.Fragment>{children}</React.Fragment> : <PolyfillTabsButtons>{children}</PolyfillTabsButtons>;
}

export default TabContainer;
